export const Property = {
    A11Y_ITERATION_FOR_INLINE_CHOICE: 'A11Y_ITERATION_FOR_INLINE_CHOICE',
    A11Y_ITERATION_FOR_REGIONS: 'A11Y_ITERATION_FOR_REGIONS',
    ENABLE_AUDIOSCRIPT_WITHOUT_GRIDLINES: 'ENABLE_AUDIOSCRIPT_WITHOUT_GRIDLINES',
    DEFAULT_ALLOW_STIMULUS_RESIZING: 'DEFAULT_ALLOW_STIMULUS_RESIZING',
    ENABLE_BACKGROUND_AUDIO_PLAYABILITY_CHECK: 'ENABLE_BACKGROUND_AUDIO_PLAYABILITY_CHECK',
    ENABLE_CANDIDATE_TIMEOUT_WARNING: 'ENABLE_CANDIDATE_TIMEOUT_WARNING',
    ENABLE_CHROMEBOOK_ADDITIONAL_DISPLAY_DETECTION: 'ENABLE_CHROMEBOOK_ADDITIONAL_DISPLAY_DETECTION',
    ENABLE_CKEDITOR_PROCESS_NUMERICAL: 'ENABLE_CKEDITOR_PROCESS_NUMERICAL',
    ENABLE_COLLAPSIBLE_DRAWING_MODAL: 'ENABLE_COLLAPSIBLE_DRAWING_MODAL',
    ENABLE_ESSAY_TEXT_ALIGN_IN_PLAYER: 'ENABLE_ESSAY_TEXT_ALIGN_IN_PLAYER',
    ENABLE_MARKING_WORD_COUNT: 'ENABLE_MARKING_WORD_COUNT',
    ENABLE_PAUSE_WITH_STOP_TIME: 'ENABLE_PAUSE_WITH_STOP_TIME',
    ENABLE_PLAYER_ANNOTATIONS_AND_HIGHLIGHTING: 'ENABLE_PLAYER_ANNOTATIONS_AND_HIGHLIGHTING',
    ENABLE_PLAYER_FOOTER_FOR_QUESTION: 'ENABLE_PLAYER_FOOTER_FOR_QUESTION',
    ENABLE_PROCTOR_AUDIO_RECORDING: 'ENABLE_PROCTOR_AUDIO_RECORDING',
    ENABLE_RECORDING_DURATION_COUNTER: 'ENABLE_RECORDING_DURATION_COUNTER',
    ENABLE_RETRIEVING_ASSETS_DOWNLOAD_INFO: 'ENABLE_RETRIEVING_ASSETS_DOWNLOAD_INFO',
    ENABLE_SANITISE_NON_PRINTABLE_CHARS_FROM_ANSWER: 'ENABLE_SANITISE_NON_PRINTABLE_CHARS_FROM_ANSWER',
    ENABLE_SECTION_MANUAL_SELECTION_V2: 'ENABLE_SECTION_MANUAL_SELECTION_V2',
    ENABLE_SHOW_REMAINING_TIME_SECONDS: 'ENABLE_SHOW_REMAINING_TIME_SECONDS',
    ENABLE_SIMPLIFIED_SUMMARY_PAGE_FOR_PUBLIC_TEST: 'ENABLE_SIMPLIFIED_SUMMARY_PAGE_FOR_PUBLIC_TEST',
    ENABLE_TEST_INFORMATION_VIDEO_DEPENDENCY: 'ENABLE_TEST_INFORMATION_VIDEO_DEPENDENCY',
    ENFORCE_DECIMAL_POINT_IN_NUMERIC_ENTRY: 'ENFORCE_DECIMAL_POINT_IN_NUMERIC_ENTRY',
    HIDE_RESET_RESPONSE_BUTTON_PLAYER: 'HIDE_RESET_RESPONSE_BUTTON_PLAYER',
    MAX_LIVE_SESSION_RECOVERY_WAITING_TIME_SECS: 'MAX_LIVE_SESSION_RECOVERY_WAITING_TIME_SECS',
    SPELLCHECKER_DEFAULT_LANGUAGE: 'SPELLCHECKER_DEFAULT_LANGUAGE',
    UI_LANGUAGE_OVERRIDE: 'UI_LANGUAGE_OVERRIDE',
    UI_THEME_NAME: 'UI_THEME_NAME',
};

export const defaultValues = {
    [Property.A11Y_ITERATION_FOR_INLINE_CHOICE]: 0,
    [Property.A11Y_ITERATION_FOR_REGIONS]: 0,
    [Property.DEFAULT_ALLOW_STIMULUS_RESIZING]: false,
    [Property.ENABLE_BACKGROUND_AUDIO_PLAYABILITY_CHECK]: false,
    [Property.ENABLE_CANDIDATE_TIMEOUT_WARNING]: false,
    [Property.ENABLE_CHROMEBOOK_ADDITIONAL_DISPLAY_DETECTION]: false,
    [Property.ENABLE_CKEDITOR_PROCESS_NUMERICAL]: true,
    [Property.ENABLE_COLLAPSIBLE_DRAWING_MODAL]: false,
    [Property.ENABLE_ESSAY_TEXT_ALIGN_IN_PLAYER]: false,
    [Property.ENABLE_MARKING_WORD_COUNT]: false,
    [Property.ENABLE_PAUSE_WITH_STOP_TIME]: false,
    [Property.ENABLE_PLAYER_ANNOTATIONS_AND_HIGHLIGHTING]: false,
    [Property.ENABLE_PLAYER_FOOTER_FOR_QUESTION]: false,
    [Property.ENABLE_PROCTOR_AUDIO_RECORDING]: false,
    [Property.ENABLE_AUDIOSCRIPT_WITHOUT_GRIDLINES]: false,
    [Property.ENABLE_RECORDING_DURATION_COUNTER]: false,
    [Property.ENABLE_RETRIEVING_ASSETS_DOWNLOAD_INFO]: false,
    [Property.ENABLE_SANITISE_NON_PRINTABLE_CHARS_FROM_ANSWER]: false,
    [Property.ENABLE_SECTION_MANUAL_SELECTION_V2]: false,
    [Property.ENABLE_SHOW_REMAINING_TIME_SECONDS]: false,
    [Property.ENABLE_SIMPLIFIED_SUMMARY_PAGE_FOR_PUBLIC_TEST]: false,
    [Property.ENABLE_TEST_INFORMATION_VIDEO_DEPENDENCY]: false,
    [Property.ENFORCE_DECIMAL_POINT_IN_NUMERIC_ENTRY]: false,
    [Property.HIDE_RESET_RESPONSE_BUTTON_PLAYER]: false,
    [Property.MAX_LIVE_SESSION_RECOVERY_WAITING_TIME_SECS]: 3 * 60,
    [Property.SPELLCHECKER_DEFAULT_LANGUAGE]: 'auto',
    [Property.UI_LANGUAGE_OVERRIDE]: undefined,
    [Property.UI_THEME_NAME]: 'default',
};

const getMPProperty = (propertyName, defaultValue = defaultValues[propertyName]) => {
    return window.marketplaceProperties[propertyName] === undefined ? defaultValue : window.marketplaceProperties[propertyName];
};

const marketplacePropertiesService = {
    isCkeditorProcessNumericalEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_CKEDITOR_PROCESS_NUMERICAL, defaultValue);
    },

    isAnnotatingEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_PLAYER_ANNOTATIONS_AND_HIGHLIGHTING, defaultValue);
    },

    getSpellcheckerDefaultLanguage(defaultValue) {
        return getMPProperty(Property.SPELLCHECKER_DEFAULT_LANGUAGE, defaultValue);
    },

    getUiLanguageOverride(defaultValue) {
        return getMPProperty(Property.UI_LANGUAGE_OVERRIDE, defaultValue);
    },

    isPauseWithStopTimeEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_PAUSE_WITH_STOP_TIME, defaultValue);
    },

    isResetResponseButtonHidden(defaultValue) {
        return getMPProperty(Property.HIDE_RESET_RESPONSE_BUTTON_PLAYER, defaultValue);
    },

    isRetrievingAssetsDownloadInfoEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_RETRIEVING_ASSETS_DOWNLOAD_INFO, defaultValue);
    },

    getMaxLiveSessionRecoveryTimeSecs(defaultValue) {
        return getMPProperty(Property.MAX_LIVE_SESSION_RECOVERY_WAITING_TIME_SECS, defaultValue);
    },

    isCandidateTimeoutWarningEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_CANDIDATE_TIMEOUT_WARNING, defaultValue);
    },

    isSimplifiedSummaryPageForPublicTestEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_SIMPLIFIED_SUMMARY_PAGE_FOR_PUBLIC_TEST, defaultValue);
    },

    isMarkingWordCountEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_MARKING_WORD_COUNT, defaultValue);
    },

    isTestInformationVideoDependencyEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_TEST_INFORMATION_VIDEO_DEPENDENCY, defaultValue);
    },

    getUiTheme(defaultValue) {
        return getMPProperty(Property.UI_THEME_NAME, defaultValue);
    },

    isCollapsibleDrawingModalEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_COLLAPSIBLE_DRAWING_MODAL, defaultValue);
    },

    isProctorAudioRecordingEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_PROCTOR_AUDIO_RECORDING, defaultValue);
    },

    isStimulusResizingAllowed(defaultValue) {
        return getMPProperty(Property.DEFAULT_ALLOW_STIMULUS_RESIZING, defaultValue);
    },

    isQuestionFooterEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_PLAYER_FOOTER_FOR_QUESTION, defaultValue);
    },

    isSectionManualSelectionV2Enabled(defaultValue) {
        return getMPProperty(Property.ENABLE_SECTION_MANUAL_SELECTION_V2, defaultValue);
    },

    showRemainTimeSeconds(defaultValue) {
        return getMPProperty(Property.ENABLE_SHOW_REMAINING_TIME_SECONDS, defaultValue);
    },

    shouldSanitiseNonPrintableChars(defaultValue) {
        return getMPProperty(Property.ENABLE_SANITISE_NON_PRINTABLE_CHARS_FROM_ANSWER, defaultValue);
    },

    shouldHideGridLinesInAudioScript(defaultValue) {
        return getMPProperty(Property.ENABLE_AUDIOSCRIPT_WITHOUT_GRIDLINES, defaultValue);
    },

    isRecordingDurationCounterEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_RECORDING_DURATION_COUNTER, defaultValue);
    },

    getA11yIterationForRegions(defaultValue) {
        return getMPProperty(Property.A11Y_ITERATION_FOR_REGIONS, defaultValue);
    },

    getA11yIterationForInlineChoiceValue(defaultValue) {
        return getMPProperty(Property.A11Y_ITERATION_FOR_INLINE_CHOICE, defaultValue);
    },

    isBackgroundAudioCheckEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_BACKGROUND_AUDIO_PLAYABILITY_CHECK, defaultValue);
    },

    isEssayToolbarTextAlignEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_ESSAY_TEXT_ALIGN_IN_PLAYER, defaultValue);
    },

    isNumericDecimalPointEnforced(defaultValue) {
        return getMPProperty(Property.ENFORCE_DECIMAL_POINT_IN_NUMERIC_ENTRY, defaultValue);
    },

    isChromebookDisplayDetectionEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_CHROMEBOOK_ADDITIONAL_DISPLAY_DETECTION, defaultValue);
    },
};

export default marketplacePropertiesService;
